import React, { ReactElement, useState } from 'react'
import { DropdownButton } from 'react-bootstrap'

import * as S from './styled'

interface extraParameters {
    title: string | ReactElement
    value: number | string | ReactElement
}

interface Option {
    value: number| string
    label: string
    extraParameters?: extraParameters[]
}

interface ItemProps {
    option: Option
    selected: boolean
    onClick: (value: Option) => void
    isSimple: boolean
}
const Item: React.FC<ItemProps> = React.memo(({ option, selected, onClick, isSimple }) => {
    return (
        <S.ItemContainer
            isSimple={isSimple}
            className={selected ? 'selected' : ''}
            onClick={() => onClick(option)}
            style={{ cursor: 'pointer' }}
        >
            <S.ItemHeader>
                <S.ItemTitle>{option.label}</S.ItemTitle>
                <input type="radio" checked={selected} readOnly />
            </S.ItemHeader>
            <S.ItemContent>
                {option.extraParameters?.map(({ title, value }, index) => (
                    <S.SubItemContainer key={index}>
                        <S.SubItemHeader>{title}</S.SubItemHeader>
                        <S.ItemContent>{value}</S.ItemContent>
                    </S.SubItemContainer>
                ))}
            </S.ItemContent>
        </S.ItemContainer>
    )
})

interface Props {
    options: Option[]
    placeholder?: string
    value?: Option['value'] | null
    onChange: (option: Option, value: Option['value']) => void
    isSimple: boolean
}
const Select: React.FC<Props> = ({ placeholder, options, value, onChange, isSimple }) => {
    const [selectedItem, setSelectedItem] = useState<Option>()

    React.useEffect(() => {
        if (value !== undefined && value !== null) {
            setSelectedItem(options.find(opt => opt.value === value))
        }
    }, [value, options])

    const onClickItem = (option: Option) => {
        //setSelectedItem(option)
        onChange(option, option.value)
    }
    return (
        <S.Menu>
            <DropdownButton
                title={
                    selectedItem ? (
                        <span style={{ width: '100%' }}>{selectedItem.label}</span>
                    ) : (
                        <span>{placeholder}</span>
                    )
                }
                id={`dropdown-options`}
            >
                <S.Container isSimple={isSimple}>
                    <S.OptionsContainer isSimple={isSimple}>
                        {options.map((option, index) => {
                            return (
                                <Item
                                    key={index}
                                    option={option}
                                    isSimple={isSimple}
                                    selected={selectedItem?.value === option.value}
                                    onClick={onClickItem}
                                />
                            )
                        })}
                    </S.OptionsContainer>
                </S.Container>
            </DropdownButton>
        </S.Menu>
    )
}

export default Select
